import styled, { css } from 'styled-components';

export const Container = styled.div.attrs({
  className: 'new_form',
})<{ isAbsolute?: boolean; isStandalone?: boolean }>`
  display: flex;
  box-sizing: border-box;
  font-family: 'Roboto';
  text-align: center;
  border-radius: 16px;

  * {
    box-sizing: border-box;
  }

  ${(props) =>
    props.isAbsolute &&
    css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `}

  ${(props) =>
    props.isStandalone &&
    css`
      margin: 60px auto;
      box-shadow: rgba(50, 50, 50, 0.5) 0px 0px 10px 5px;
      width: fit-content;
    `}
`;

export const ImageContainer = styled.div`
  height: 630px;
  img {
    height: 100%;
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  height: 630px;

  background: #fff;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;

  width: 100%;

  @media screen and (min-width: 800px) {
    margin-left: -50px;
    width: 520px;
    padding: 24px 100px;
  }
`;

export const Title = styled.span`
  color: #1c1c1c;
  font-family: 'Playfair Display';
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  margin-top: 28px;
  cursor: default;
  user-select: none;
`;

export const Text = styled.span`
  margin-top: 42px;
  font-weight: 300;
  line-height: 24px;
  cursor: default;
  user-select: none;
  color: #141414;

  b {
    font-weight: 400;
  }
`;

export const ContentFooter = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;

  ${Text} {
    margin: 0;
    font-weight: 400;
    color: #323231;

    a {
      color: #2d5dec;
      text-decoration: none;

      &:visited {
        color: #2d5dec;
      }

      u {
        user-select: all;
      }
    }
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  padding: 16px 16px;
  width: 100%;
`;

export const ControlsBtn = styled.div`
  height: 24px;
  width: 24px;
  position: relative;
  cursor: pointer;
  border-radius: 50%;
  &::before,
  &::after {
    content: '';
    display: block;
    height: 1.5px;
    background-color: #aaaaaa;
    position: absolute;
    left: 50%;
    top: 50%;
  }
`;

export const ControlsBack = styled(ControlsBtn)`
  &::before,
  &::after {
    width: 12px;
    transform-origin: center left;
    left: 25%;
  }

  &::before {
    transform: rotate(315deg) translate(0, -50%);
    width: 13px;
  }

  &::after {
    transform: rotate(45deg) translate(0, -50%);
  }
`;

export const ControlsClose = styled(ControlsBtn)`
  margin-left: auto;
  &::before,
  &::after {
    width: 24px;
    transform-origin: center left;
    border-radius: 1px;
  }

  &::before {
    transform: rotate(45deg) translate(-50%, -50%);
  }

  &::after {
    transform: rotate(-45deg) translate(-50%, -50%);
  }
`;

export const InputWrapper = styled.form`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .MuiTextField-root {
    margin-bottom: 30px;
    box-sizing: content-box;

    * {
      box-sizing: content-box;
    }
  }

  .MuiFormHelperText-root {
    line-height: 1;
    position: absolute;
    bottom: -16px;
    font-size: 12px;
    margin: 0;
  }

  .MuiButton-root {
    height: 42px;
    text-transform: none;
    box-shadow: none;
  }

  .MuiButton-root + .MuiButton-root {
    margin-top: 10px;
  }

  .MuiButton-list {
    color: #2d5dec;
  }

  button:active {
    border: 0 !important;
  }

  input:hover {
    transform: none !important;
  }
`;

export const OtpInputWrapper = styled.div`
  display: flex;
  padding: 0 12px;
  position: relative;

  .MuiTextField-root {
    margin: 0 12px 30px;
    text-align: center;
    input {
      font-size: 25px;
      text-align: center;
    }
  }

  .MuiFormHelperText-root {
    font-size: 12px;
    width: 100%;
    display: block;
    text-align: center;
    bottom: 12px;
  }
`;

export const AltLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .MuiButton-root {
    height: 42px;
    text-transform: none;
    font-weight: 400;
    box-shadow: none;
  }

  .MuiButton-outlined {
    border-color: #ccc;
    color: #323231;
  }
`;

export const AltLoginDivider = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #ccc;
  margin: 30px auto 36px;
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-transform: uppercase;

  &::before,
  &::after {
    content: '';
    background: currentColor;
    position: absolute;
    height: 1px;
    width: calc(50% - 46px / 2);
    top: 50%;
  }

  &::before {
    left: 0;
    transform: translate(0, -50%);
  }

  &::after {
    right: 0;
    transform: translate(0, -50%);
  }
`;
